import QuickSearchAutosuggestContainer from './QuickSearchAutosuggestContainer';
import { dispatchSetInputValue, dispatchRunSearch, dispatchClearSearch } from './QuickSearchAutosuggestActions';

export function setReactInputValue(inputValue) {
  return dispatchSetInputValue(inputValue);
}

export function getSearchFromStore() {
  return dispatchRunSearch();
}

export function clearSearchInStore() {
  return dispatchClearSearch();
}

export default QuickSearchAutosuggestContainer;
